import axios from '../axios';

class Api {
    static getAllSoortbelichting () {
        return axios.get('/soortbelichting/allbynaam');
    }

    static getListSoortbelichting () {
        return axios.get('/soortbelichting/list');
    }

    static getDetailSoortbelichting (id) {
        return axios.get(`/soortbelichting/${id}`);
    }

    static addSoortbelichting (payload) {
        return axios.post('/soortbelichting', payload);
    }

    static updateSoortbelichting (payload) {
        return axios.post(`/soortbelichting/update/${payload.id}`, payload);
    }

    static deleteSoortbelichting (payload) {
        return axios.post(`/soortbelichting/delete/${payload}`);
    }
}

export default Api;



// WEBPACK FOOTER //
// ./src/api/soortbelichting.js